/** Merge tags for QMS document library staff assign emails (dbo.QMSConfig). */

export const QMS_LIBRARY_STAFF_ASSIGN_EMAIL_MERGE_TAGS = [
  { tag: "{{StaffName}}", entityName: "StaffName", description: "Assigned staff display name" },
  { tag: "{{DocumentTitle}}", entityName: "DocumentTitle", description: "Document title" },
  { tag: "{{DocumentCode}}", entityName: "DocumentCode", description: "Document category number + version" },
  {
    tag: "{{DocumentOpenLink}}",
    entityName: "DocumentOpenLink",
    description: "Open document button — use this only (do not build your own link)",
  },
  { tag: "{{DocumentId}}", entityName: "DocumentId", description: "Document unique id" },
  { tag: "{{VersionNumber}}", entityName: "VersionNumber", description: "Document version number" },
  {
    tag: "{{OrganizationName}}",
    entityName: "OrganizationName",
    description: "Organisation display name",
  },
];

/** Remove emails must not include document links — staff no longer have library access. */
export const QMS_LIBRARY_STAFF_REMOVE_EMAIL_MERGE_TAGS = [
  { tag: "{{StaffName}}", entityName: "StaffName", description: "Removed staff display name" },
  { tag: "{{DocumentTitle}}", entityName: "DocumentTitle", description: "Document title" },
  { tag: "{{DocumentCode}}", entityName: "DocumentCode", description: "Document category number + version" },
  { tag: "{{DocumentId}}", entityName: "DocumentId", description: "Document unique id (reference only)" },
  { tag: "{{VersionNumber}}", entityName: "VersionNumber", description: "Document version number" },
  {
    tag: "{{OrganizationName}}",
    entityName: "OrganizationName",
    description: "Organisation display name",
  },
];

/** @deprecated Use assign/remove-specific tag lists. */
export const QMS_LIBRARY_STAFF_EMAIL_MERGE_TAGS = QMS_LIBRARY_STAFF_ASSIGN_EMAIL_MERGE_TAGS;
